import React, { Component } from "react";
import {Rule} from "../../models/mailroom-school-config-rules/Rule";
import {ConditionalConfigItem} from "./ConditonalConfigItem";
import {NameBuilder} from "./NameBuilder";
import {Dictionary} from "lodash";
import {MailroomSchoolConfig} from "../../models/MailroomSchoolConfig";

export interface ConfigNameBuilderProps {
    namePath: string;
    configRules: Rule[];
    config: MailroomSchoolConfig;
    onConfigChanged(newConfig: MailroomSchoolConfig): void;
}

export interface ConfigNameBuilderState {
}

export class ConfigNameBuilder extends Component<ConfigNameBuilderProps, ConfigNameBuilderState> {

    constructor(props: ConfigNameBuilderProps) {
        super(props);

        this.state = {
        };
    }

    public async componentDidMount()
    {
    }

    public componentDidUpdate(prevProps: Readonly<ConfigNameBuilderProps>, prevState: Readonly<ConfigNameBuilderState>, snapshot?: any)
    {
    }

    public render() {
        return (
                <ConditionalConfigItem path={["classNames",this.props.namePath]} config={this.props.config!} configRules={this.props.configRules!}>
                    {(rule) => {
                        
                        const actualPartNames = this.props.config[this.props.namePath] as string[];
                        return (
                            <NameBuilder 
                                title={this.props.namePath}
                                actualPartNames={actualPartNames}
                                defaultNameParts={rule.defaultValue}
                                availablePartNames={rule.options?.map(o => o.option as string)!}
                                onChange={(newPartNames) =>
                                {
                                    const patch: Dictionary<string[]> = {};
                                    patch[this.props.namePath] = newPartNames;
                                    
                                    const newConfig = Object.assign({}, this.props.config, patch);
                                    this.props.onConfigChanged(newConfig);
                                }
                            }/>
                        );
                    }}
                </ConditionalConfigItem>
        );
    }
}